const serializedError = error => {
  if (error?.stack) {
    return error.toString()
  }
  return JSON.stringify(error)
}

export default function (error, vm, info) {
  console.error("Error:", serializedError(error))
  console.error("Additional Info:", info)

  // 限制仅在客户端异常捕获
  if (process.client) {
    return true
  }
}
